import { apiRequest } from './api'

export function listInvoices() {
  return apiRequest('/invoices/list', {
    method: 'POST',
  })
}

export function createInvoice(payload) {
  return apiRequest('/invoices/create', {
    method: 'POST',
    body: JSON.stringify(payload),
  })
}

export function updateInvoice(payload) {
  return apiRequest('/invoices/update', {
    method: 'POST',
    body: JSON.stringify(payload),
  })
}

export function deleteInvoice(invoiceId) {
  return apiRequest('/invoices/delete', {
    method: 'POST',
    body: JSON.stringify({ invoiceId }),
  })
}
